import React from 'react';
import styles from './Divider.module.css';

const Divider = ({ isHorizontal = false }) => {
  return <div className={isHorizontal ? styles.dividerHorizontal : styles.divider}></div>;
};

export default Divider;
